var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{attrs:{"id":"loading"}},[_c('div',{attrs:{"id":"loading-center"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }